module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie E. Cooper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Julie E. Cooper")]), _vm._v(" is assistant professor of political science at the University of Chicago.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/x1vKl0/tc-custom/9780226081328.jpg?1733034391864",
      "alt": "This image is the cover for the book Secular Powers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secular Powers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Secularism is usually thought to contain the project of self-deification, in which humans attack God’s authority in order to take his place, freed from all constraints. Julie E. Cooper overturns this conception through an incisive analysis of the early modern justifications for secular politics. While she agrees that secularism is a means of empowerment, she argues that we have misunderstood the sources of secular empowerment and the kinds of strength to which it aspires."), _c('br'), _vm._v(" Contemporary understandings of secularism, Cooper contends, have been shaped by a limited understanding of it as a shift from vulnerability to power. But the works of the foundational thinkers of secularism tell a different story. Analyzing the writings of Hobbes, Spinoza, and Rousseau at the moment of secularity’s inception, she shows that all three understood that acknowledging one’s limitations was a condition of successful self-rule. And while all three invited humans to collectively build and sustain a political world, their invitations did not amount to self-deification. Cooper establishes that secular politics as originally conceived does not require a choice between power and vulnerability. Rather, it challenges us—today as then—to reconcile them both as essential components of our humanity.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0